import { AnalyticsRepository } from '../../domain/repositories/analytics.repository';
import {
  RawProductView,
  RawSearchLog,
  RawProductInquiry,
} from '../../domain/entities/analytics.entity';

export class GetAnalyticsRawDataUseCase {
  constructor(private readonly analyticsRepository: AnalyticsRepository) {}

  public async getProductViews(
    page: number = 1,
    limit: number = 20,
    search?: string
  ): Promise<{ items: RawProductView[]; total: number }> {
    return await this.analyticsRepository.getProductViews(page, limit, search);
  }

  public async getSearchLogs(
    page: number = 1,
    limit: number = 20,
    search?: string
  ): Promise<{ items: RawSearchLog[]; total: number }> {
    return await this.analyticsRepository.getSearchLogs(page, limit, search);
  }

  public async getProductInquiries(
    page: number = 1,
    limit: number = 20,
    search?: string
  ): Promise<{ items: RawProductInquiry[]; total: number }> {
    return await this.analyticsRepository.getProductInquiries(page, limit, search);
  }
}
